import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Editor } from '@tinymce/tinymce-react';
import SidebarLayout from 'components/Layout/Layout';
import { API_URL } from 'env';
import { Modal } from 'antd';

const AddProduct: React.FC = () => {
  const navigate = useNavigate();
  const [imageBase64, setImageBase64] = useState('');
  const editorRef = useRef<any>(null);

  const [form, setForm] = useState({
    product_id: 0,
    locale: 'vi',
    title: '',
    subtitle: '',
    description: '',
  });

  const [productList, setProductList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  // Gọi API lấy danh sách products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(`${API_URL}api/v1/be/products`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        const json = await res.json();
        console.log('products json:', json);

        // lấy mảng an toàn theo nhiều cấu trúc phổ biến
        const list =
          Array.isArray(json) ? json
          : Array.isArray(json?.data) ? json.data
          : Array.isArray(json?.data?.data) ? json.data.data      // {data:{data:[...]}}
          : Array.isArray(json?.data?.items) ? json.data.items    // {data:{items:[...]}}
          : Array.isArray(json?.result) ? json.result
          : [];

        setProductList(list);
      } catch (e) {
        console.error(e);
        setProductList([]); // tránh map lỗi
      }
    };
    fetchProducts();
  }, []);

  const handleSave = async () => {
    if (!form.product_id) {
      Modal.warning({ title: 'Thiếu thông tin', content: 'Vui lòng chọn sản phẩm' });
      return;
    }
    if (!form.title.trim()) {
      Modal.warning({ title: 'Thiếu thông tin', content: 'Vui lòng nhập tiêu đề' });
      return;
    }

    try {
      setLoading(true);
      const payload = {
        ...form,
      };

      const response = await fetch(`${API_URL}api/v1/be/introductions`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const json = await response.json();

      if (json.status) {
        Modal.success({
          title: 'Thành công',
          content: 'Thêm mới thành công',
          onOk: () => navigate('/product'),
        });
      } else {
        Modal.error({
          title: 'Lỗi',
          content: json.message || 'Unknown error',
        });
      }
    } catch (error: any) {
      Modal.error({
        title: 'Lỗi khi thêm mới',
        content: error.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SidebarLayout title={<h4 className="text-2xl font-bold !m-0 py-4">Thêm mới Introduction</h4>}>
      <div className="p-4 bg-white rounded shadow">

        {/* Select product_id */}
        <div className="mb-4">
          <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
            Chọn sản phẩm
          </label>
          <select
            value={form.product_id || 0}
            onChange={(e) => setForm({ ...form, product_id: Number(e.target.value) })}
            className="w-full border p-2 rounded"
            style={{ border: '1px solid #ccc' }}
          >
            <option value={0}>-- Chọn sản phẩm --</option>
            {(productList || []).map((p: any) => (
              <option key={p.id} value={p.id}>
                {p.title || p.name || `#${p.id}`}
              </option>
            ))}
          </select>
        </div>

        {/* Locale */}
        <div className="mb-4">
          <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
            Ngôn ngữ
          </label>
          <select
            value={form.locale}
            onChange={(e) => setForm({ ...form, locale: e.target.value })}
            className="w-full border p-2 rounded"
          >
            <option value="vi">Vietnam</option>
            <option value="en">English</option>
          </select>
        </div>

        {/* Title */}
        <div className="mb-4">
          <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
            Title
          </label>
          <input
            type="text"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            className="w-full border p-2 rounded"
            style={{ border: '1px solid #ccc' }}
          />
        </div>

        {/* Subtitle */}
        <div className="mb-4">
          <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
            Subtitle
          </label>
          <input
            type="text"
            value={form.subtitle}
            onChange={(e) => setForm({ ...form, subtitle: e.target.value })}
            className="w-full border p-2 rounded"
          />
        </div>

        {/* Description */}
        <div className="mb-4">
          <label className="block font-semibold mb-1" style={{ color: '#5e5873' }}>
            Nội dung
          </label>
          <Editor
            apiKey="8idrshqq41s3566uw9r35h7yd71a2lhzpzfkn6pywrmjf26k"
            value={form.description}
            onInit={(_, editor) => (editorRef.current = editor)}
            onEditorChange={(content) => setForm({ ...form, description: content })}
            init={{ height: 300 }}
          />
        </div>

        {/* Upload image */}

        <div className="flex justify-end gap-2">
          <button onClick={() => navigate('/daily')} className="border px-4 py-2 rounded" disabled={loading}>
            Hủy
          </button>
          <button
            onClick={handleSave}
            className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
            disabled={loading}
          >
            {loading ? 'Đang xử lý...' : 'Thêm'}
          </button>
        </div>
      </div>
    </SidebarLayout>
  );
};

export default AddProduct;
